enum InvoiceAgreementStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  INVALID = 'INVALID',
}

export default InvoiceAgreementStatus;
